export default {
    DETECT_PROVIDER: (email) => `/imapEmail/detectProvider?email=${encodeURIComponent(email)}`,
    CONNECT: () => `/imapEmail/connect`,
    LIST: () => `/imapEmail/`,
    GET_BY_ID: (id) => `/imapEmail/${id}`,
    GET_ALL_INBOX_IMAP: (query) => `/email/getAllInboxIMap?${query}`,
    SEARCH_IMAP: (query) => `/email/searchImap?${query}`,
    DELETE: (id) => `/imapEmail/${id}`,
};
